import {
    GET_SURVIVORSHIP_RULESET_REQUEST,
    GET_SURVIVORSHIP_RULESET_SUCCESS,
    GET_SURVIVORSHIP_RULESET_FAILURE,
    SAVE_SURVIVORSHIP_RULESET_REQUEST,
    SAVE_SURVIVORSHIP_RULESET_SUCCESS,
    SAVE_SURVIVORSHIP_RULESET_FAILURE,
    GET_SURVIVORSHIP_DATASETS_SUCCESS,
    GET_SURVIVORSHIP_DATASETS_FAILURE,
} from "./actions";

const initialState = {
    // The schema's saved ruleset (null = none configured yet).
    ruleset: null,
    // Datasets of the schema being configured (for the trust sliders).
    schemaDataSets: [],
    getRulesetResult: { success: true },
    saveRulesetResult: { success: true },
    saving: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_SURVIVORSHIP_RULESET_REQUEST:
            // Clear the previous schema's data so it can never bleed into this one.
            return { ...state, ruleset: null, schemaDataSets: [], getRulesetResult: { success: true } };
        case GET_SURVIVORSHIP_RULESET_SUCCESS:
            return { ...state, ruleset: action.payload, getRulesetResult: { success: true } };
        case GET_SURVIVORSHIP_RULESET_FAILURE:
            return { ...state, getRulesetResult: { success: false, ...action.payload } };
        case SAVE_SURVIVORSHIP_RULESET_REQUEST:
            return { ...state, saving: true };
        case SAVE_SURVIVORSHIP_RULESET_SUCCESS:
            return { ...state, ruleset: action.payload, saving: false, saveRulesetResult: { success: true } };
        case SAVE_SURVIVORSHIP_RULESET_FAILURE:
            return { ...state, saving: false, saveRulesetResult: { success: false, ...action.payload } };
        case GET_SURVIVORSHIP_DATASETS_SUCCESS:
            return { ...state, schemaDataSets: action.payload };
        case GET_SURVIVORSHIP_DATASETS_FAILURE:
            return { ...state, schemaDataSets: [] };
        default:
            return state;
    }
};
